// Client task reference codes (FIQ-1570): "SCH" + schedule reference tag + zero-padded
// frequency, e.g. SCHELERCD01Y. Derived on the fly wherever needed, never persisted,
// so the code always reflects the current tag and frequency.
export function getPaddedFrequencyLabel(frequency) {
    if (!frequency || typeof frequency !== "object") return ""
    const { interval, period } = frequency
    // Frequency intervals are whole non-negative numbers; anything else (negative,
    // fractional, Infinity, NaN, strings) must not leak into a code like "SCHTAG-1Y"
    if (!Number.isInteger(interval) || interval < 0) return ""
    if (typeof period !== "string" || !period.length) return ""
    // Zero or Unknown frequencies collapse to "00U", matching the existing "0U" convention
    if (interval === 0 || period === "Unknown") return "00U"
    // Intervals above 99 stay unpadded (padStart is a no-op), e.g. "120M"
    return `${String(interval).padStart(2, "0")}${period[0].toUpperCase()}`
}

export function getTaskReferenceCode({ tag, frequency } = {}) {
    const normalizedTag = typeof tag === "string" ? tag.trim().toUpperCase() : ""
    const frequencyLabel = getPaddedFrequencyLabel(frequency)
    // Both parts must be valid: a blank tag must not yield "SCH01Y" and a malformed
    // frequency must not yield a dangling "SCH<tag>"
    if (!normalizedTag || !frequencyLabel) return ""
    return `SCH${normalizedTag}${frequencyLabel}`
}
